// What this browser says about where its owner is, for the account's default
// units (TOM-744, ADR 0409): its IANA time zone only. A browser's language tag
// is not where the person is ("en-US" is the default language of browsers far
// outside the US), so the web sends no region; the app sends the device's own
// Region setting instead. The server decides; this only reports, and a zone it
// cannot read is "nothing said".

export interface DeviceUnitSignals {
  timeZone?: string;
}

export function deviceUnitSignals(
  read: { timeZone?: () => string | undefined } = {}
): DeviceUnitSignals {
  let zone: string | undefined;
  try {
    zone = (read.timeZone ?? (() => Intl.DateTimeFormat().resolvedOptions().timeZone))();
  } catch {
    zone = undefined;
  }
  return typeof zone === 'string' && zone.length > 0 && zone.length <= 64 ? { timeZone: zone } : {};
}
